{
    "PlaysoundLabel": "Sound abspielen (erfordert lokalen Mediaplayer):",
    "ActivewindowLabel": "Aktives Fenster (nur IE\/Firefox-Browser mit einer Registerkarte):",
    "AlarmActions_SectionHeader": "Alarmaktionen",
    "AlarmActions_SectionPara": "Wenn Alarme aktiviert sind, blinken die entsprechende Berichtszeile und\/oder Statistiken. Unten können Sie zusätzliche Aktionen auswählen, die für den derzeit aktiven Bericht ausgeführt werden, wenn einer seiner Alarme zum ersten Mal ausgelöst wird.",
    "NAME": "AlarmActions"
}